import React from "react";
import { Carousel, Card } from "antd";

export default function About() {
  // 主题背景图配置
  const themeImages = [
    {
      title: "武侠水墨",
      image: "/背景图_武侠.png",
      description: "满堂花醉三千客，一剑霜寒十四州"
    },
    {
      title: "赛博朋克", 
      image: "/背景图_赛博朋克.png",
      description: "霓虹灯光与未来科技的结合"
    },
    {
      title: "自然风光",
      image: "/背景图_自然.png",
      description: "久在樊笼里，复得返自然"
    },
    {
      title: "泪如雨崩",
      image: "/背景图_雨崩.png",
      description: "若夜幕终临，勿泪如雨崩"
    },
    {
      title: "萌宠乐园",
      image: "/背景图_萌宠.png",
      description: "可爱萌宠的温馨世界"
    },
    {
      title: "万家灯火",
      image: "/背景图_万家灯火.png",
      description: "繁华散尽，人比烟花寂寞"
    }
  ];

  // 冒泡词云文字 - 包含固定位置信息
  const bubbleWords = [
    { text: "欢迎", left: "18%", top: "35%" },
    { text: "他心游", left: "55%", top: "22%" },
    { text: "前端", left: "78%", top: "32%" },
    { text: "随机型后端", left: "25%", top: "58%" },
    { text: "博客", left: "48%", top: "48%" },
    { text: "项目展示", left: "72%", top: "63%" },
    { text: "探索", left: "32%", top: "75%" },
    { text: "分享", left: "52%", top: "72%" },
    { text: "创造", left: "68%", top: "78%" },
    { text: "爬虫", left: "15%", top: "55%" },
    { text: "文本生成", left: "65%", top: "38%" },
    { text: "图像识别", left: "85%", top: "48%" },
    { text: "网页", left: "40%", top: "28%" }
  ];


  return (
    <div style={{ maxWidth: 1200, margin: "0 auto", padding: "20px" }}>
      {/* 引入内联样式 */}
      <style jsx>{`
        /* 标题动画 */
        @keyframes titleFloat {
          0%, 100% { transform: translateY(0) scale(1); }
          50% { transform: translateY(-10px) scale(1.05); }
        }
        
        /* 气泡动画 - 修复初始瞬移问题，确保整个动画过程中都保持居中定位 */
        @keyframes bubble {
          0% {
            transform: translate(-50%, -50%) translateY(0) scale(1);
            opacity: 0.9;
          }
          50% {
            transform: translate(-50%, -50%) translateY(-30px) scale(1.1);
            opacity: 1;
          }
          100% {
            transform: translate(-50%, -50%) translateY(0) scale(1);
            opacity: 0.9;
          }
        }
        
        .animated-title {
          animation: titleFloat 3s ease-in-out infinite;
          display: inline-block;
          position: relative;
        }
        
        .bubble-cloud {
          position: relative;
          height: 300px;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          align-items: center;
          overflow: hidden;
        }
        
        .bubble-word {
          position: absolute;
          color: var(--theme-text);
          font-size: 18px;
          font-weight: 500;
          opacity: 0.9;
          transition: all 0.3s ease;
          cursor: pointer;
          text-shadow: 0 2px 4px rgba(0,0,0,0.1);
          padding: 8px 16px;
          border: 2px solid var(--theme-primary);
          border-radius: 25px;
          background: var(--theme-card-bg);
          /* 初始位置已经包含居中定位，与动画初始状态一致 */
          transform: translate(-50%, -50%) translateY(0) scale(1);
          animation-fill-mode: both; /* 确保动画结束后保持最终状态 */
          animation-play-state: running; /* 确保动画立即运行 */
        }
        
        .bubble-word:hover {
          color: white;
          background: var(--theme-primary);
          font-weight: bold;
          transform: translate(-50%, -50%) translateY(0) scale(1.2) !important;
          opacity: 1 !important;
          z-index: 10;
          border-color: var(--theme-secondary);
          box-shadow: 0 5px 15px rgba(var(--theme-primary-rgb), 0.3);
        }
        
        /* 为每个气泡设置随机动画延迟和持续时间 */
        .bubble-word:nth-child(1) { animation: bubble 4s ease-in-out infinite 0s; }
        .bubble-word:nth-child(2) { animation: bubble 5s ease-in-out infinite 0.5s; }
        .bubble-word:nth-child(3) { animation: bubble 3s ease-in-out infinite 1s; }
        .bubble-word:nth-child(4) { animation: bubble 4.5s ease-in-out infinite 1.5s; }
        .bubble-word:nth-child(5) { animation: bubble 3.5s ease-in-out infinite 2s; }
        .bubble-word:nth-child(6) { animation: bubble 5.5s ease-in-out infinite 2.5s; }
        .bubble-word:nth-child(7) { animation: bubble 4s ease-in-out infinite 3s; }
        .bubble-word:nth-child(8) { animation: bubble 3.8s ease-in-out infinite 3.5s; }
        .bubble-word:nth-child(9) { animation: bubble 4.2s ease-in-out infinite 4s; }
        .bubble-word:nth-child(10) { animation: bubble 3.7s ease-in-out infinite 0.3s; }
        .bubble-word:nth-child(11) { animation: bubble 4.8s ease-in-out infinite 1.2s; }
        .bubble-word:nth-child(12) { animation: bubble 4.3s ease-in-out infinite 2.7s; }
        .bubble-word:nth-child(13) { animation: bubble 3.9s ease-in-out infinite 3.3s; }
      `}</style>

      {/* 去掉背景框的介绍部分 */}
      <div style={{ padding: 30, marginBottom: 20, minHeight: 300 }}>
        {/* 动态标题 */}
        <div className="page-title animated-title" style={{ fontSize: 42, marginBottom: 40, textAlign: "center" }}>
          关于
        </div>
        
        {/* 冒泡词云效果 - 固定位置避免重叠，修复初始瞬移问题 */}
        <div className="bubble-cloud">
          {bubbleWords.map((word, index) => (
            <div 
              key={index}
              className="bubble-word"
              style={{
                left: word.left,
                top: word.top,
                fontSize: `${Math.random() * 8 + 16}px`,
                borderColor: index % 2 === 0 ? 'var(--theme-primary)' : 'var(--theme-secondary)',
                background: 'rgba(255, 255, 255, 0.8)'
              }}
            >
              {word.text}
            </div>
          ))}
        </div>
      </div>

      {/* 主题背景图轮播 - 保持原有功能 */}
      <Card 
        className="card-glow" 
        title="主题背景展示" 
        style={{ marginBottom: 20 }}
      >
        <Carousel 
          autoplay 
          effect="fade"
          autoplaySpeed={3000}
          dots={true}
          infinite={true}
          pauseOnHover={false}
          pauseOnFocus={false}
          adaptiveHeight={false}
          style={{ 
            borderRadius: 8,
            overflow: "hidden"
          }}
        >
          {themeImages.map((theme, index) => (
            <div key={index}>
              <div
                style={{
                  height: 300,
                  background: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url('${theme.image}')`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "white",
                  textAlign: "center",
                  padding: 20
                }}
              >
                <h3 style={{ 
                  fontSize: "24px", 
                  fontWeight: "bold",
                  marginBottom: 10,
                  textShadow: "0 2px 4px rgba(0,0,0,0.5)"
                }}>
                  {theme.title}
                </h3>
                <p style={{ 
                  fontSize: "16px",
                  textShadow: "0 1px 2px rgba(0,0,0,0.5)",
                  maxWidth: 400
                }}>
                  {theme.description}
                </p>
              </div>
            </div>
          ))}
        </Carousel>
        
        <div style={{ 
          marginTop: 15, 
          textAlign: "center",
          color: "var(--theme-text)",
          fontSize: "14px"
        }}>
          点击右上角"主题设置"按钮可以切换不同的主题风格
        </div>
      </Card>
    </div>
  );
}